export default __webpack_public_path__ + "media/images/home/corporate/sm-e12c2bccd87acdfb56d8a103199ba7cb.jpg";